export type GovernorPlacementId =
  | "executive"
  | "tree"
  | "application-experience"
  | "calls"
  | "messaging"
  | "membership"
  | "business"
  | "kinsspace"
  | "media"
  | "security-auth"
  | "deployment"
  | "runtime-event-bus"
  | "learning-incident-memory"
  | "verification"
  | "repair-self-healing"
  | "performance";

export interface GovernorPlacement {
  id: GovernorPlacementId;
  name: string;
  parent: GovernorPlacementId | null;
  children: GovernorPlacementId[];
  purpose: string;
}

type RawGovernorPlacement = Omit<GovernorPlacement, "children">;

const RAW_EXECUTIVE_GOVERNOR_PLACEMENT_MAP: RawGovernorPlacement[] = [
  {
    id: "executive",
    name: "Executive Governor",
    parent: null,
    purpose: "Supervises all Governors, enforces the Constitution, and coordinates the Governor OS."
  },
  {
    id: "tree",
    name: "Tree Governor",
    parent: "executive",
    purpose: "Modern family relationships and tree integrity."
  },
  {
    id: "application-experience",
    name: "Application Experience Governor",
    parent: "executive",
    purpose: "Navigation, onboarding, routing, and UX."
  },
  {
    id: "calls",
    name: "Calls Governor",
    parent: "executive",
    purpose: "Calling lifecycle, signaling, runtime evidence, and diagnostics."
  },
  {
    id: "messaging",
    name: "Messaging Governor",
    parent: "executive",
    purpose: "Messaging integrity and delivery."
  },
  {
    id: "membership",
    name: "Membership Governor",
    parent: "executive",
    purpose: "Subscriptions, seats, entitlements, and membership policies."
  },
  {
    id: "business",
    name: "Business & Revenue Governor",
    parent: "executive",
    purpose: "Pricing, billing, revenue, and business governance."
  },
  {
    id: "kinsspace",
    name: "KinsSpace Governor",
    parent: "executive",
    purpose: "Storage, uploads, archives, quotas, and media storage."
  },
  {
    id: "media",
    name: "Media Governor",
    parent: "executive",
    purpose: "Photos, videos, timelines, and media integrity."
  },
  {
    id: "security-auth",
    name: "Security/Auth Governor",
    parent: "executive",
    purpose: "Authentication, authorization, identity, and security."
  },
  {
    id: "deployment",
    name: "Deployment Governor",
    parent: "executive",
    purpose: "Builds, releases, deployments, and rollback readiness."
  },
  {
    id: "runtime-event-bus",
    name: "Runtime/Event Bus Governor",
    parent: "executive",
    purpose: "Runtime events, telemetry, and Governor communication."
  },
  {
    id: "learning-incident-memory",
    name: "Learning & Incident Memory Governor",
    parent: "executive",
    purpose: "Learning, incident history, and continuous improvement."
  },
  {
    id: "verification",
    name: "Verification Governor",
    parent: "executive",
    purpose: "Runtime proof, validation, and constitutional compliance."
  },
  {
    id: "repair-self-healing",
    name: "Repair/Self-Healing Governor",
    parent: "executive",
    purpose: "Repair planning, recovery workflows, and self-healing."
  },
  {
    id: "performance",
    name: "Performance Governor",
    parent: "executive",
    purpose: "Performance, scalability, and operational efficiency."
  }
];

export const EXECUTIVE_GOVERNOR_PLACEMENT_MAP: GovernorPlacement[] =
  RAW_EXECUTIVE_GOVERNOR_PLACEMENT_MAP.map(item => ({
    ...item,
    children: RAW_EXECUTIVE_GOVERNOR_PLACEMENT_MAP
      .filter(child => child.parent === item.id)
      .map(child => child.id),
  }));
